import moment from 'moment';

export const getHours = () => {
  const hrs = [];
  hrs.push({ value: '', title: 'hr' });
  for (let i = 1; i <= 12; i += 1) {
    hrs.push({ value: `${i}`, title: `${i}` });
  }
  return hrs;
};

export const minutes = [
  {
    value: '',
    title: 'mm',
  },
  {
    value: '0',
    title: '00',
  },
  {
    value: '15',
    title: '15',
  },
  {
    value: '30',
    title: '30',
  },
  {
    value: '45',
    title: '45',
  },
];

export const timezones = [
  {
    value: '',
    title: 'Guess',
  },
  {
    value: 'America/New_York',
    title: 'America/New_York',
  },
  {
    value: 'America/Los_Angeles',
    title: 'America/Los_Angeles',
  },
  {
    value: 'America/Denver',
    title: 'America/Denver',
  },
  {
    value: 'America/Phoenix',
    title: 'America/Phoenix',
  },
  {
    value: 'America/Chicago',
    title: 'America/Chicago',
  },
];

export const timezonesV2 = [
  {
    value: 'America/New_York',
    label: `New York - ${moment().tz('America/New_York').format('z')}`,
  },
  {
    value: 'America/Chicago',
    label: `Chicago - ${moment().tz('America/Chicago').format('z')}`,
  },
  {
    value: 'America/Denver',
    label: `Denver - ${moment().tz('America/Denver').format('z')}`,
  },
  {
    value: 'America/Phoenix',
    label: `Phoenix - ${moment().tz('America/Phoenix').format('z')}`,
  },
  {
    value: 'America/Los_Angeles',
    label: `Los Angeles - ${moment().tz('America/Los_Angeles').format('z')}`,
  },
  {
    value: 'America/Anchorage',
    label: `Anchorage - ${moment().tz('America/Anchorage').format('z')}`,
  },
  {
    value: 'Pacific/Honolulu',
    label: `Hawaii - ${moment().tz('US/Hawaii').format('z')}`,
  },
];

const getTimes = () => {
  const times = [];
  [...Array(24)].forEach((_, i) => {
    [0, 15, 30, 45].forEach(min => {
      const value = { hour: i, minute: min };
      const label = moment(value).format('h:mm a');
      times.push({ value: label, label });
    });
  });
  return times;
};

export const startTimes = getTimes();



// WEBPACK FOOTER //
// ./src/components/common/form/timeValues.js